import React from "react";

import { Card, Divider, Stack, Typography } from '@material-ui/core';
import { ChatData } from "../../types";
import { ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import timeAgo from "../../utils/timeAgo";



interface Props {
  chat: ChatData;
}

const ChatDetails: React.FC<Props> = ({ chat }) => {
  return (
    <Card variant="outlined" sx={{ p: 2, overflow: 'scroll' }} >
      <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
        <Stack direction="row" spacing={1}>
          <ProfileAvatar userId={chat.users[ 0 ]} size={100} showName />
          <ProfileAvatar userId={chat.users[ 1 ]} size={100} showName />
        </Stack>

        <Stack direction="column">
          <Typography variant="body2" noWrap>Total messages: {chat.messagesCount?.total}</Typography>
          <Typography variant="body2" noWrap>Active: {chat.messagesCount?.active}</Typography>
          <Typography variant="body2" noWrap>Text: {chat.messagesCount?.text}</Typography>
          <Typography variant="body2" noWrap>Photo: {chat.messagesCount?.photo}</Typography>
          <Typography variant="body2" noWrap>Giphy: {chat.messagesCount?.giphy}</Typography>
          <Typography variant="body2" noWrap>Sticker: {chat.messagesCount?.sticker}</Typography>
          <Typography variant="body2" noWrap>Voice: {chat.messagesCount?.voice}</Typography>
        </Stack>

        <Stack direction="column">
          <Typography variant="body2" noWrap>Status: {chat.status}</Typography>
          <Typography variant="body2" noWrap>Created: {timeAgo(chat.createTime.toDate())}</Typography>
          <Typography variant="body2" noWrap>Updated: {timeAgo(chat.updateTime.toDate())}</Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export default ChatDetails;